import * as React from 'react';

function SvgPromotions(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={50} height={50} {...props}>
      <defs>
        <style>{'.promotions_svg__prefix__cls-2{fill:#7689b4}'}</style>
      </defs>
      <g id="promotions_svg__prefix__promotions" transform="translate(-26 -593)">
        <path
          id="promotions_svg__prefix__bounds"
          fill="none"
          d="M0 0h50v50H0z"
          transform="translate(26 593)"
        />
        <g id="promotions_svg__prefix__commerce" transform="translate(31 602)">
          <path
            id="promotions_svg__prefix__Path_5052"
            d="M40.553 155.568a.6.6 0 01-.6-.6v-8.2a.6.6 0 011.2 0v8.2a.6.6 0 01-.6.6zm0 0"
            className="promotions_svg__prefix__cls-2"
            data-name="Path 5052"
            transform="translate(-36.758 -134.481)"
          />
          <path
            id="promotions_svg__prefix__Path_5053"
            d="M40.553 287.123a.6.6 0 01-.6-.6v-3.279a.6.6 0 111.2 0v3.279a.6.6 0 01-.6.6zm0 0"
            className="promotions_svg__prefix__cls-2"
            data-name="Path 5053"
            transform="translate(-36.758 -260.038)"
          />
          <path
            id="promotions_svg__prefix__Path_5054"
            d="M71.549 307.82a.6.6 0 01-.6-.6v-1.479a.6.6 0 111.2 0v1.479a.6.6 0 01-.6.6zm0 0"
            className="promotions_svg__prefix__cls-2"
            data-name="Path 5054"
            transform="translate(-65.275 -280.735)"
          />
          <path
            id="promotions_svg__prefix__Path_5055"
            d="M71.549 255.828a.6.6 0 01-.6-.6v-1.479a.6.6 0 111.2 0v1.479a.6.6 0 01-.6.6zm0 0"
            className="promotions_svg__prefix__cls-2"
            data-name="Path 5055"
            transform="translate(-65.275 -232.902)"
          />
          <path
            id="promotions_svg__prefix__Path_5056"
            d="M71.549 202.339a.6.6 0 01-.6-.6v-1.479a.6.6 0 111.2 0v1.479a.6.6 0 01-.6.6zm0 0"
            className="promotions_svg__prefix__cls-2"
            data-name="Path 5056"
            transform="translate(-65.275 -183.691)"
          />
          <path
            id="promotions_svg__prefix__Path_5057"
            d="M71.549 148.851a.6.6 0 01-.6-.6v-1.479a.6.6 0 011.2 0v1.479a.6.6 0 01-.6.6zm0 0"
            className="promotions_svg__prefix__cls-2"
            data-name="Path 5057"
            transform="translate(-65.275 -134.481)"
          />
          <path
            id="promotions_svg__prefix__Path_5061"
            d="M407.716 354.477h-5.038a.6.6 0 100 1.2h5.038a.6.6 0 100-1.2zm0 0"
            className="promotions_svg__prefix__cls-2"
            data-name="Path 5061"
            transform="translate(-369.92 -326.125)"
          />
          <path
            id="promotions_svg__prefix__Path_5062"
            d="M434.6 326.48h-2.7a.6.6 0 100 1.2h2.7a.6.6 0 100-1.2zm0 0"
            className="promotions_svg__prefix__cls-2"
            data-name="Path 5062"
            transform="translate(-396.802 -300.368)"
          />
          <path
            id="promotions_svg__prefix__Path_5063"
            d="M328.992 239.11v1.757c0 1.151.751 1.563 1.733 1.563s1.721-.412 1.721-1.563v-1.757c0-1.139-.751-1.563-1.721-1.563s-1.733.424-1.733 1.563zm1.054 0a.6.6 0 01.678-.654.6.6 0 01.691.654v1.757a.6.6 0 01-.691.654.6.6 0 01-.678-.654zm0 0"
            className="promotions_svg__prefix__cls-2"
            data-name="Path 5063"
            transform="translate(-302.679 -218.547)"
          />
          <path
            id="promotions_svg__prefix__Path_5064"
            d="M287.636 181.34a.472.472 0 00-.436.255l-4.362 8.833a.573.573 0 00-.048.206.562.562 0 00.57.533.5.5 0 00.472-.266l4.362-8.8a.477.477 0 00.048-.218.6.6 0 00-.606-.546zm0 0"
            className="promotions_svg__prefix__cls-2"
            data-name="Path 5064"
            transform="translate(-260.172 -166.836)"
          />
          <path
            id="promotions_svg__prefix__Path_5065"
            d="M262.4 187.4c-.982 0-1.733.424-1.733 1.563v1.757c0 1.139.751 1.563 1.733 1.563s1.721-.424 1.721-1.563v-1.757c.004-1.137-.747-1.563-1.721-1.563zm.69 3.32a.6.6 0 01-.69.654.6.6 0 01-.679-.654v-1.757a.6.6 0 01.679-.655.6.6 0 01.69.655zm0 0"
            className="promotions_svg__prefix__cls-2"
            data-name="Path 5065"
            transform="translate(-239.823 -172.413)"
          />
          <path
            id="promotions_svg__prefix__Path_5066"
            d="M219.915 137.425a8.342 8.342 0 00-4.856 1.546.6.6 0 10.695.978 7.193 7.193 0 11-1.805 1.847.6.6 0 00-.994-.671 8.4 8.4 0 106.961-3.7zm0 0"
            className="promotions_svg__prefix__cls-2"
            data-name="Path 5066"
            transform="translate(-194.602 -126.434)"
          />
          <path
            id="promotions_svg__prefix__Path_5067"
            d="M39.32 6.766h-5.1l.005-.016 2.652-.823a.938.938 0 000-1.792l-2.652-.823L33.4.66a.938.938 0 00-1.792 0l-.823 2.652-2.652.823a.938.938 0 000 1.792l2.652.823v.016H12.3a2.616 2.616 0 00-2.02.953 2.615 2.615 0 00-2.02-.953H1.63A1.632 1.632 0 000 8.4v12.447a.6.6 0 101.2 0V8.4a.431.431 0 01.431-.431h6.626a1.421 1.421 0 011.42 1.42v20a1.421 1.421 0 01-1.42 1.42H1.63a.431.431 0 01-.431-.431v-6.736a.6.6 0 00-1.2 0v6.738a1.632 1.632 0 001.63 1.63h6.628a2.616 2.616 0 002.02-.953 2.615 2.615 0 002.02.953H39.32a1.632 1.632 0 001.63-1.63V8.4a1.632 1.632 0 00-1.63-1.63zM29.292 5.031l1.979-.614a.938.938 0 00.618-.618L32.5 1.82l.617 1.98a.937.937 0 00.618.618l1.979.614-1.979.614a.938.938 0 00-.618.618L32.5 8.242l-.614-1.979a.939.939 0 00-.618-.618zm10.459 25.348a.431.431 0 01-.431.431H12.3a1.421 1.421 0 01-1.42-1.42v-20a1.421 1.421 0 011.42-1.42h18.861l.446 1.43a.938.938 0 001.792 0l.446-1.436h5.475a.431.431 0 01.431.431zm0 0"
            className="promotions_svg__prefix__cls-2"
            data-name="Path 5067"
          />
          <path
            id="promotions_svg__prefix__Path_5068"
            d="M161.2 292.855l-1.636-.508-.508-1.636a.822.822 0 00-1.57 0l-.508 1.636-1.636.508a.822.822 0 000 1.57l1.636.508.508 1.636a.822.822 0 001.57 0l.508-1.636 1.636-.508a.822.822 0 000-1.57zm-2.181.991a.821.821 0 00-.541.541l-.206.664-.206-.664a.822.822 0 00-.541-.541l-.664-.206.664-.206a.822.822 0 00.541-.541l.206-.664.206.664a.822.822 0 00.541.541l.664.206zm0 0"
            className="promotions_svg__prefix__cls-2"
            data-name="Path 5068"
            transform="translate(-142.384 -266.927)"
          />
        </g>
      </g>
    </svg>
  );
}

export default SvgPromotions;
